<bot-online *ngIf="!isOnline"></bot-online>

<router-outlet></router-outlet>

<div class="dss-display-none">
    <dss-content-loader [show]="true" [path]="'assets/page-loader/default.json'">
    </dss-content-loader>
</div>